var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Spacer } from 'shared/components/ui';
import useWindowDimensions from 'shared/hooks/useWindowDimensionsHook';
import { NavItem, HomeNavItem } from '.';
var processNavItems = function (_a) {
    var navItems = _a.navItems;
    var bottomIndex = -1;
    var items = navItems.map(function (navItem, index) {
        if (navItem.isPinnedToBottom && bottomIndex < 0) {
            bottomIndex = index;
        }
        return (_jsx(NavItem, { icon: navItem.icon, activeIcon: navItem.activeIcon, title: navItem.title, url: navItem.url, onclick: navItem.onclick, isActive: navItem.isActive, isDisabled: navItem.isDisabled, isPinnedToBottom: navItem.isPinnedToBottom, badgeIcon: navItem.badgeIcon, badgeColor: navItem.badgeColor }, index));
    });
    if (bottomIndex >= 0) {
        items.splice(bottomIndex, 0, _jsx(Spacer, {}, "-1"));
    }
    return items;
};
/**
 * The side navigation bar component
 *
 * @param {SideNavProps} props - The props passed to the component
 * @property {SideNavProps.navItems} navItems - Array of nav items to render
 * @returns {React.ReactNode}
 */
export var SideNav = function (props) {
    /**
     * Render the side navigation
     */
    var _a = useWindowDimensions(), height = _a.height, width = _a.width;
    var innerRef = props.innerRef, navItems = props.navItems, viewAsEnabled = props.viewAsEnabled;
    var boxHeight = height;
    if (viewAsEnabled) {
        boxHeight = boxHeight - 60;
    }
    return (_jsx(Box, __assign({ top: 0, pos: "sticky", h: boxHeight.toString() + 'px', minHeight: boxHeight.toString() + 'px', w: "75px", flexShrink: 0, ref: innerRef }, { children: _jsx(Flex, __assign({ h: "100%", w: "100%", flexDir: "column", 
            //justifyContent="space-between"
            border: "1px", borderColor: "gray.300", "data-testid": "side-nav" }, { children: _jsxs(Flex, __assign({ flexDir: "column", w: "100%", h: "100%", mb: 4, alignItems: 'center', as: "nav" }, { children: [_jsx(HomeNavItem, {}), processNavItems(props)] })) })) })));
};
